import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OnlineMeetingLobbyComponent } from './components/online-meeting-lobby/online-meeting-lobby.component';
import { OnlineMeetingsComponent } from './components/online-meetings/online-meetings.component';
import { OnlineMeetingDetailsComponent } from './components/online-meeting-details/online-meeting-details.component';
import { PerfectScrollbarConfigInterface, PerfectScrollbarModule, PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
	suppressScrollX: true
};

@NgModule({
  declarations: [OnlineMeetingLobbyComponent, OnlineMeetingsComponent, OnlineMeetingDetailsComponent],
  imports: [
    CommonModule,
    PerfectScrollbarModule
  ],
  providers: [
		{
			provide: PERFECT_SCROLLBAR_CONFIG,
			useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
		}]
})
export class OnlineMeetingsModule { }
